interface Permission {
  [key: string]: string
}

interface OperationPermissions {
  is_admin?: boolean
  permissions?: string[]
}

interface OrganizationPermissions {
  is_admin?: boolean
  permissions?: string[]
}

interface PermissionsObject {
  operations: {
    [key: string]: OperationPermissions
  }
  organizations: {
    [key: string]: OrganizationPermissions
  }
}

interface HasPermParams {
  perm: string[]
  operation: string | null
  perms: PermissionsObject | null
}

interface UserIsAdminParams {
  org: string | null
  perms: PermissionsObject | null
}

interface CheckPermsParams {
  perm: string[]
  is_admin?: boolean
  org: string | null
  team: string | null
  project: string | null | undefined
  perms: PermissionsObject | null
  checkAllProjects?: boolean
}

const has_perm = ({
  perm = [],
  operation = null,
  perms = null
}: HasPermParams): boolean => {
  let hasPerm = false

  // If a project is given in argument
  if (perm && perms && operation !== null) {
    perm.forEach(p => {
      if (
        perms.operations[operation]?.is_admin ||
        perms.operations[operation]?.permissions?.includes(p)
      ) {
        hasPerm = true
      }
    })
  }
  return hasPerm
}

const userIsAdmin = ({
  org = null,
  perms = null
}: UserIsAdminParams): boolean => {
  if (perms && org && perms.organizations[org]) {
    return !!perms.organizations[org]?.is_admin
  }
  return false
}

export const checkPerms = ({
  perm = [],
  is_admin = false,
  org = null,
  team = null,
  project = null,
  perms = null,
  checkAllProjects = false
}: CheckPermsParams): boolean => {
  return true // disable perms for now

  // if (org === null || perms === null) {
  //   return false;
  // }

  // if (perms['organizations'] === undefined) {
  //   return false;
  // }

  // if (is_admin && !userIsAdmin({ org: org, perms: perms }) && perm === null) {
  //   return false;
  // }

  // // If the user is admin, no need to check perm(s)
  // if (userIsAdmin({ org: org, perms: perms })) {
  //   return true;
  // }

  // if (!perm) {
  //   return false;
  // }

  // // If an org is given in argument
  // if (org !== null) {
  //   // If we have perm(s) to check && the user have any of them in the org && no team or project are given in arguments
  //   if (!has_perm({ perm: perm, org: org, perms: perms }) && project === null) {
  //     return false;
  //   }
  // }

  // // If a project is given in argument
  // if (project !== null && project !== undefined) {
  //   // If we have perm(s) to check && the user have any of them in the project
  //   if (!has_perm({ perm: perm, operation: project, perms: perms })) {
  //     return false;
  //   }
  // }
  // return true;
}
